'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fButton$002ejs from "@ui5/webcomponents/dist/Button.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-button");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$.prototype = $p;
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fButton$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$, "io.github.nguyenyou.ui5.webcomponents.laminar.Button$", ({
  jz: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Button$ };
